import tooltip from '@/core/charts/components/tooltip-standard'

export default {
  chartType: 'Pie',
  showInChartLegend: true,
  chartOpts: getOptions(),

  chartData: (widget, data) => getChartData(widget, data),
  chartInfo: (widget, data) => getChartInfo(data, 1),
  drillDown: (ctx, value, index) => executeDrillDown(ctx, value, index),
  drillDownReturn: (ctx) => reverseDrillDown(ctx),

  components: {
    tooltip
  }
}

function getOptions() {
  let baseCustSet = {
    chartGroupValue: 'Hotel Chain',
    showTotal: true,
    recalculateGridMax: false,
    hasDrillDown: true,
    chartInfoTooltip: true,
    containterStyle: 'height: 270px; margin-top: 3px; margin-left: 0px;',
    tooltip: {
      width: '200px'
    }
  }
  let baseOpts = {
    customSettings: baseCustSet,
    donut: true,
    donutWidth: 90,
    height: '260px',
    width: '260px'
  }
  return baseOpts
}

function getChartInfo(dataIn, pos) {
  let result = []
  dataIn.forEach(elem => {
    let gdPos = result.findIndex(k => k[0] === elem[pos])
    if (gdPos === -1) result.push(elem[pos])
  })
  return result.map(k => k[0])
}

function getChartData(widget, data) {
  let sortedData = prepareData(widget, data, 1)
  sortedData = getTopDataGroup(sortedData, 'Other Hotel Chains')
  let seriesGrouped = sortedData.map(k => k[1])
  return {
    labels: sortedData.map(k => k[0]),
    series: seriesGrouped.map(q => Math.abs(q)),
    labelData: seriesGrouped,
    tooltipData: {
      helpText: 'Click on the slice to see Brand level spend details.',
      metadata: tooltipMetadata,
      data: [
        sortedData.map(t => t[0]),
        seriesGrouped
      ]
    }
  }
}

function getTopDataGroup (data, otherText) {
  let maxItems = 8
  if (data.length > maxItems && data.length !== maxItems + 1) {
    let otherIt = [otherText, 0]
    for (let i = maxItems; i < data.length; i++) {
      otherIt[1] += data[i][1]
    }
    data.splice(maxItems, data.length - maxItems)
    data.push(otherIt)
  }
  return data
}

function getChartDataDrilled(data, widget) {
  let sortedData = prepareData(widget, data, 0)
  sortedData = getTopDataGroup(sortedData, 'Other Hotel Brands')
  let seriesGrouped = sortedData.map(k => k[1])
  return {
    labels: sortedData.map(k => k[0]),
    series: seriesGrouped.map(q => Math.abs(q)),
    labelData: seriesGrouped,
    tooltipData: {
      metadata: tooltipMedatadaDrilled,
      data: [
        sortedData.map(t => t[0]),
        seriesGrouped
      ]
    }
  }
}

function executeDrillDown(ctx, value) {
  let chain = value
  let fullData = ctx.rawData.filter(row => ~row.indexOf(chain))
  let newChartData = getChartDataDrilled(fullData, ctx)
  ctx.chartData = newChartData
  ctx.chartInfo = newChartData.labels
  ctx.chartComponent.chartOpts.customSettings.hasDrillDown = false
  ctx.chartComponent.chartOpts.customSettings.tooltip = {
    width: '235px',
    topOffset: -10,
    leftOffset: 50
  }
  ctx.$emit('childRedraw')
}

function reverseDrillDown(ctx) {
  ctx.chartComponent.chartOpts = getOptions()
  ctx.chartComponent.chartOpts.customSettings.hasDrillDown = true
  ctx.$emit('childRedraw')
}

function prepareData(widget, data, ind) {
  let scenarioIndex = getVariableIndex(widget)
  if (data.length === 0) return {labels: null, series: []}
  let labelsGrouped = []
  data.forEach(chain => {
    let label = chain[ind]
    if (label === null || label === '') label = 'No Brand'
    let pos = labelsGrouped.findIndex(k => k[0] === label)
    let value = getSumBasedOnScenario(chain, scenarioIndex)
    if (pos === -1) {
      labelsGrouped.push([label, value])
    } else {
      labelsGrouped[pos][1] += value
    }
  })
  let sortedData = labelsGrouped.slice(0)
  sortedData.sort(function (a, b) { return b[1] - a[1] })
  return sortedData
}

function getVariableValue(widget) {
  let wgt = widget.variables ? widget.variables : widget.widget.variables
  let variable = wgt.filter(function(s) {
    if (s.name === 'PaymentStatusFilter') return s.value[0]
    else return null
  })
  return variable[0].value[0]
}

function getSumBasedOnScenario (chain, scenarioIndex) {
  let sum = 0
  if (scenarioIndex === 1) {
    sum = chain[3]
  } else if (scenarioIndex === 2) {
    sum = chain[5] + chain[6] + (chain[2] === true ? chain[3] : 0)
  } else if (scenarioIndex === 3) {
    sum = chain[4] + chain[7]
  }
  return sum
}

function getVariableIndex(widget) {
  let variableVal = getVariableValue(widget)
  if (variableVal === 'TotalSpend') return 1
  else if (variableVal === 'PaidSpend') return 2
  return 3 // open spend
}

const ttLabel = 'Total Spend'
const tooltipMetadata = [
  {
    label: '',
    type: 'title',
    format: ''
  },
  {
    label: ttLabel,
    type: 'main',
    format: 'currency'
  }
]
const tooltipMedatadaDrilled = [
  {
    label: '',
    type: 'title',
    format: ''
  },
  {
    label: ttLabel,
    type: 'main',
    format: 'currency'
  }
]



// WEBPACK FOOTER //
// ./src/components/_modules/Dashboard/widgets/HotelSpend/chart.js